import React from "react";
import styled from "styled-components";
import tw from "twin.macro";
//eslint-disable-next-line
import { css } from "styled-components/macro";
import { SectionHeading } from "components/misc/Headings.js";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons.js";

import defaultCardImage from "../../images/shield-icon.svg";

import { ReactComponent as SvgDecoratorBlob3 } from "../../images/svg-decorator-blob-3.svg";

import SupportIconImage from "../../images/shield-icon.svg";
import ShieldIconImage from "../../images/twitter-icon.png";
import CustomizeIconImage from "../../images/facebook-icon.svg";
import FastIconImage from "../../images/fast-icon.svg";
import ReliableIconImage from "../../images/reliable-icon.svg";
import SimpleIconImage from "../../images/simple-icon.svg";

const Container = tw.div`relative`;

const PrimaryButton = styled(PrimaryButtonBase)(props => [
  tw`mt-8 md:mt-8 text-sm inline-block mx-auto md:mx-0`,
  props.buttonRounded && tw`rounded-full`
]);

const ThreeColumnContainer = styled.div`
  ${tw`flex flex-col items-center md:items-stretch md:flex-row flex-wrap md:justify-center max-w-screen-xl mx-auto py-20 md:py-24`}
`;
const Heading = tw(SectionHeading)`w-full`;

const Column = styled.div`
  ${tw`md:w-1/2 lg:w-1/3 px-6 flex`}
`;

const Card = styled.div`
  ${tw`flex flex-col mx-auto max-w-xs items-center px-6 py-10 border-2 border-dashed border-primary-500 rounded-lg mt-12`}
  .imageContainer {
    ${tw`border-2 border-primary-500 text-center rounded-full p-6 flex-shrink-0 relative`}
    img {
      ${tw`w-8 h-8`}
    }
  }

  .textContainer {
    ${tw`mt-6 text-center`}
  }

  .title {
    ${tw`mt-2 font-bold text-xl leading-none text-primary-500`}
  }

  .description {
    ${tw`mt-3 font-semibold text-secondary-100 text-sm leading-loose`}
  }
  
  
`;

const DecoratorBlob = styled(SvgDecoratorBlob3)`
  ${tw`pointer-events-none absolute right-0 bottom-0 w-64 opacity-25 transform translate-x-32 translate-y-48 `}
`;

export default () => {
  /*
   * This componets has an array of object denoting the cards defined below. Each object in the cards array can have the key (Change it according to your need, you can also add more objects to have more cards in this feature component):
   *  1) imageSrc - the image shown at the top of the card
   *  2) title - the title of the card
   *  3) description - the description of the card
   *  If a key for a particular card is not provided, a default value is used
   */

  const cards = [
    {
      imageSrc: ShieldIconImage,
      primaryButtonUrl: "https://twitter.com/Wolves_Game",
      primaryButtonText: "Twitter",
      description: "Follow us on Twitter for the most up-to-date announcements and a glimpse into other Battletech related projects!"
    },
    { imageSrc: SupportIconImage,
      primaryButtonUrl: "https://discord.gg/cb8frFg",
      primaryButtonText: "Discord",
      description: "We create and manage ads that you need, from creation to deployment. Lorem ipsum donor sit amet consicou."},
    { imageSrc: CustomizeIconImage,
      primaryButtonUrl: "https://facebook.com/WolvesGame",
      primaryButtonText: "Facebook",
      description: "We create and manage ads that you need, from creation to deployment. Lorem ipsum donor sit amet consicou."},
    { imageSrc: ReliableIconImage,
      primaryButtonUrl: "https://youtube.com/channel/UCuYQXYPBlpe0lqcprSCWaCg",
      primaryButtonText: "YouTube",
      description: "We create and manage ads that you need, from creation to deployment. Lorem ipsum donor sit amet consicou."},
    { imageSrc: FastIconImage,
      primaryButtonUrl: "https://reddit.com/r/WolvesGame",
      primaryButtonText: "Reddit",
      description: "We create and manage ads that you need, from creation to deployment. Lorem ipsum donor sit amet consicou."},
    { imageSrc: SimpleIconImage,
      primaryButtonUrl: "http://indiedb.com/games/wolves",
      primaryButtonText: "IndieDB",
      description: "We create and manage ads that you need, from creation to deployment. Lorem ipsum donor sit amet consicou."}
  ];

  return (
    <Container>
      <ThreeColumnContainer>
        <Heading>Our <span tw="text-primary-100">Socials</span></Heading>
        {cards.map((card, i) => (
          <Column key={i}>
            <Card>
              <span className="imageContainer">
                <img src={card.imageSrc || defaultCardImage} alt="" />
              </span>
              <span className="textContainer">
                <PrimaryButton buttonRounded="true" as="a" href={card.primaryButtonUrl}>
                  {card.primaryButtonText}
                </PrimaryButton>
                <p className="description">
                  {card.description || "Lorem ipsum donor amet siti ceali ut enim ad minim veniam, quis nostrud. Sic Semper Tyrannis. Neoas Calie artel."}
                </p>
              </span>
            </Card>
          </Column>
        ))}
      </ThreeColumnContainer>
      <DecoratorBlob />
    </Container>
  );
};
